// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autosave-indicator {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.85rem;
  padding: 0.25rem 0;
  line-height: 1.4;
}

.autosave-pending {
  color: #9ca3af;
}

.autosave-saving {
  color: #9ca3af;
}

.autosave-saved {
  color: #16a34a;
}

.autosave-error {
  color: #ef4444;
}

/* Spinner inline */
.autosave-spinner {
  display: inline-block;
  width: 0.8rem;
  height: 0.8rem;
  border: 2px solid #d1d5db;
  border-top-color: #6b7280;
  border-radius: 50%;
  animation: autosave-spin 0.6s linear infinite;
}

@keyframes autosave-spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/composants/AutoSaveIndicator/AutoSaveIndicator.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".autosave-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.85rem;\n  padding: 0.25rem 0;\n  line-height: 1.4;\n}\n\n.autosave-pending {\n  color: #9ca3af;\n}\n\n.autosave-saving {\n  color: #9ca3af;\n}\n\n.autosave-saved {\n  color: #16a34a;\n}\n\n.autosave-error {\n  color: #ef4444;\n}\n\n/* Spinner inline */\n.autosave-spinner {\n  display: inline-block;\n  width: 0.8rem;\n  height: 0.8rem;\n  border: 2px solid #d1d5db;\n  border-top-color: #6b7280;\n  border-radius: 50%;\n  animation: autosave-spin 0.6s linear infinite;\n}\n\n@keyframes autosave-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
